import SelectItemModal from 'template/Modals/SelectItem';
import getPosterList from 'controllers/poster/getPosterList'

export default function(opts) {
  const {
    schoolId,
    itemPerPage = 25,
  } = opts;

  // this will return a promise
  return SelectItemModal({
    headerTitle: __('Select Poster', 'registrationTable'),
    headerIcon: 'fa icon-userss',
    itemName: __('Poster Title', 'registrationTable'),
    searchPlaceholder: __('Select Poster', 'registrationTable'),
    backendSearch: true,
    getItemLabel: (item)=>{
      return item.cName;
    },
    fetchItems: (cb, fetchOpts)=>{
      const {
        searchKeyword,
        currentPageNumber,
      } = fetchOpts;

      getPosterList(
        schoolId,
        3,
        itemPerPage,
        currentPageNumber,
        searchKeyword
      )
      .then((data)=>{
        const { 
          result_list,
          page_amount,
        } = data;
        const pageMeta = {
          maxPageNumber: page_amount,
        };
        let newPosterList = []
        result_list.map((poster) => {
          newPosterList.push({id: poster.id, cName: poster.title})
        })

        cb(newPosterList, pageMeta);
      })
      .catch((err)=>{ console.error(err); });
    },

    ...opts,

  })
}



// WEBPACK FOOTER //
// ./src/template/Modals/SelectPoster/index.js